export default __webpack_public_path__ + "static/media/orange3-small.7943855a.png";